import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/case-studies',
    name: 'CaseStudies',
    component: () => import(/* webpackChunkName: "case-studies" */ '../views/Case-studies.vue')
  },
  {
    path: '/types',
    name: 'Types',
    component: () => import(/* webpackChunkName: "types" */ '../views/Types-of-action.vue')
  },
  {
    path: '/evaluation',
    name: 'Evaluation',
    component: () => import(/* webpackChunkName: "evaluation" */ '../views/Evaluation-page.vue')
  },
  {
    path: '/infrastruktur',
    name: 'Infrastruktur',
    component: () => import(/* webpackChunkName: "infrastruktur" */ '../views/Infrastruktur-page.vue')
  },
  {
    path: '/page/:slug',
    name: 'Page',
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
